import styled from 'styled-components';

import { Modal, Paragraph } from '@dexma/ui-components';

type WrapperProps = {
    hasSaveAndProceedButton: boolean;
};

export const StyledConfirmActionModal = styled(Modal)<WrapperProps>`
    white-space: pre-line;
    p {
        margin: 0;
    }
    top: calc(50% - 220px);

    .ant-modal-header {
        border-bottom: none;
    }
`;
export const StyledModalLabelParagraph = styled(Paragraph)`
    margin: 1rem 0rem 8px 0;
`;
